import Service from '../abstract/service'

export default class Relatorios extends Service
{
  constructor() {
    super()

    this._colaboradorCollection = this._db.collection(`${this._prefix}-gruposEmpresas/${this._grupoPrincipal}/Colaboradores`)
    this._usuarioCollection = this._db.collection(`Usuarios`)
  }


  ///<summary>
  /// tipoBusca: 0 - Todos, 1 - Possui usuario, 2 - Não possui usuario
  ///</summary>
  async getColaboradorUsuario(empresas, tipoBusca)
  {
    let arrData = new Array()

    try
    {
      for(let empresa of empresas)
      {
        let colaboradoresSnapshot = await this._colaboradorCollection.where('empresas', 'array-contains', empresa).get()
        if(colaboradoresSnapshot.empty) continue

        for(let colaboradorDoc of colaboradoresSnapshot.docs)
        {
          let colaborador = colaboradorDoc.data()

          let userSnapshot = await this._usuarioCollection.doc(colaborador.cpf).get()
          let userData = userSnapshot.exists ? userSnapshot.data() : null

          switch (tipoBusca)
          {
            case '0':
              arrData.push({
                ...colaborador,
                email: userData ? userData.email : '',
                telefone: userData ? userData.telefone : '',
                apelido: userData ? userData.apelido : '',
                possuiUsuario: userSnapshot.exists
              })
            break;
            case '1':
              if(userSnapshot.exists)
              {
                arrData.push({
                  ...colaborador,
                  email: userData ? userData.email : '',
                  telefone: userData ? userData.telefone : '',
                  apelido: userData ? userData.apelido : '',
                  possuiUsuario: userSnapshot.exists
                })
              }
            break;
            case '2':
              if(!userSnapshot.exists)
              {
                arrData.push({
                  ...colaborador,
                  email: userData ? userData.email : '',
                  telefone: userData ? userData.telefone : '',
                  apelido: userData ? userData.apelido : '',
                  possuiUsuario: userSnapshot.exists
                })
              }
            break;
          }
        }
      }

      return Promise.resolve(arrData)
    }
    catch(error)
    {
      return Promise.reject(error)
    }
  }
}
